import Section from "./Section";
import CenterListSearch from "./CenterSearchList";
import {SalubrisContext} from './Context';
import SearchMap from "./SearchMap";
import BackLink from './Back';
import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loader from "./Loader";
import { useState } from "react";

import mixpanel from 'mixpanel-browser';
mixpanel.init('dad63d43256c11b54faf7cf812a51631');

const SearchResult = () => {

    let params = useParams();
    const {centers, actions} = useContext(SalubrisContext);
    const [isLoading, setLoading] = useState(true);
    const [sortByDistance, updateSort] = useState(false);
    const [offset, setOffset] = useState(0);

    useEffect(()=> {

        let config = {
            method: 'post',
            url: `https://app.sal.health/api/locations`,
            headers: { 
                'Authorization': 'Bearer 2|'+process.env.REACT_APP_SALUBRIS_API_KEY
            },
            params: params
        };
              
        axios(config).then( res => {

            const centers = res.data.sort((center1,center2) => center1.distance > center2.distance ? 1: -1);
            actions.setCenters(centers);  
            setLoading(false);
        });

        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        mixpanel.track_pageview({"page":`Search results`});
        return () => window.removeEventListener('scroll', onScroll);

      }, [params]);

    const handleSort = (centers) => {

        const centersCopy = [...centers];
        if(sortByDistance)
            centersCopy.sort((center1,center2) => center1.distance > center2.distance ? 1: -1);
        else
            centersCopy.sort((center1,center2) => center1.name > center2.name ? 1: -1);

        updateSort(!sortByDistance);
        actions.setCenters(centersCopy);
    }
    
    const  renderSortBy = () => {

        return (
            <div className="sort-container">
                <label>Sort By:</label>
                <select className="sort-select" onChange={(() => handleSort(centers))}>
                    <option value={0}>Distance</option>
                    <option value={1}>Alphabetically</option>
                </select>
            </div>
        );
    }

    var elements = [ <BackLink key={1} text="back to search" path="/find-doctors" />,
        <Section  key={2} extraClasses="no-banner with-padding">
            <h1 className="light">Search Results for <strong>Locations</strong> near <strong>{params.location}</strong></h1>
        </Section>];
    if(isLoading)
        elements.push(<Loader key={3} />);
    else{

        if(centers && centers.length) {

            elements.push(<SearchMap key={3} />);
            elements.push(<Section key={4} extraClasses="with-padding">
                            {renderSortBy()}
                            {<CenterListSearch />}   
                            {offset > 500 && <button className="button back-to-map dt" onClick={() =>  window.scrollTo({top: 0, behavior: 'smooth'})}>Back to Map</button>  }       
                        </Section>);
        }
        else elements.push( <Section key={3} extraClasses="with-padding"><h4>Not Centers match the search criteria</h4></Section>)
    }
    return (elements);
}

export default SearchResult;